import Settings from "@/components/Settings";
import InfoPanel from "@/views/MainHeader/PersonalInfo/InfoPanel";
import { Divider, HeaderWrapper, Logo, NavGroup, NavItem, Project, Title, UserSection } from "@/views/MainHeader/styled";
import { CommentOutlined, CompassOutlined, SettingOutlined } from "@ant-design/icons";
import amzLogo from "@images/amazon-logo.png";
import { useAppSelector } from "@redux/store";
import { Image, Popover } from "antd";
import { useTranslation } from "react-i18next";

function MainHeader() {
  const { t } = useTranslation();
  const user = useAppSelector(state => state.user);

  const handleNavClick = (url: string) => {
    if (url) {
      window.open(url, "_blank")?.focus();
    }
  };

  const getUserInitial = (username: string) => {
    return username ? username.charAt(0).toUpperCase() : "U";
  };

  return (
    <HeaderWrapper>
      <Title onClick={() => (location.href = "/")}>
        <Logo>
          <Image width="6rem" preview={false} src={amzLogo} />
          <span>{t("header.title")}</span>
        </Logo>
        <Project>{t("header.subtitle")}</Project>
      </Title>

      <NavGroup>
        <NavItem onClick={() => handleNavClick("")}>
          <CompassOutlined className="nav-icon" />
          <span className="nav-text">{t("header.guide")}</span>
        </NavItem>

        <NavItem onClick={() => handleNavClick("")}>
          <CommentOutlined className="nav-icon" />
          <span className="nav-text">{t("header.contactUs")}</span>
        </NavItem>

        <Divider />

        <Popover content={<Settings />} placement="bottomRight" trigger="hover">
          <NavItem>
            <SettingOutlined className="nav-icon" />
            <span className="nav-text">{t("header.settings")}</span>
          </NavItem>
        </Popover>

        <Popover content={<InfoPanel />} placement="bottomRight" trigger="hover" align={{ offset: [4, 6] }}>
          <UserSection>
            <div className="user-avatar">{getUserInitial(user.username)}</div>
            <div className="user-info">
              <span className="user-name">{user.username || "User"}</span>
            </div>
          </UserSection>
        </Popover>
      </NavGroup>
    </HeaderWrapper>
  );
}

export default MainHeader;
